import IModel from "./IModel";

export enum ActiveType {
	Zalo = 1,
	WhatsApp = 2,
}
export const ActiveTypeMap = new Map([
	[ActiveType.Zalo, "Zalo"],
	[ActiveType.WhatsApp, "WhatsApp"],
]);

export default class LoginModel implements IModel<LoginModel> {
	accessToken?: string;
	message?: string;
	expiredIn?: string;
	userId?: number;
	refreshToken?: string;
	constructor(input?: Partial<LoginModel>) {
		this.accessToken = input?.accessToken;
		this.message = input?.message;
		this.expiredIn = input?.expiredIn;
		this.userId = input?.userId;
		this.refreshToken = input?.refreshToken;
	}

	parse(json?: any): LoginModel {
		if (!json) return this;

		Object.assign(this, {
			...json,
		});

		return this;
	}
	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new LoginModel().parse(item));
	}
	clone(): LoginModel {
		return new LoginModel({
			...this,
		});
	}
}
